import { Navigate } from "react-router-dom";
import { isTokenExpired } from "../utils/Auth/auth";

const PrivateRoute = ({ children }: any) => {
  const token = localStorage.getItem("token");

  if (!token || isTokenExpired(token)) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoute;